// UserModal.js
import React from 'react';
import './EventsModal.css';

const EventsModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="events-modal">
      <div className="events-modal-content">
        <h2 className='events-title'>Events Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default EventsModal;
